import React, { useState } from "react";
import { FiMenu, FiX } from "react-icons/fi"; // Import FiMenu and FiX
import { navItems } from "./LPNaviMenu";
import logo from "../assets/images/scholarty-01-blk.png";
import { useNavigate } from "react-router-dom";

const LPHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const actualNavItems = navItems;

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white text-black top-0 z-50">
      <div className="container mx-auto pt-4 pb-2">
        <div className="flex items-center justify-between pl-4 relative">
          {/* Branding */}
          <div className="flex flex-col">
            <img
              src={logo}
              alt="Scholarty Logo"
              className="w-28 xs:w-32 sm:w-36 md:w-40 lg:w-44 xl:w-48 2xl:w-52 cursor-pointer"
              onClick={() => {
                navigate("/");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default LPHeader;
